module.exports = __webpack_public_path__ + "static/media/tree_dark.689190ea.png";